<div id="sync-solution-panel" class="ot-panel">
  <div class="ot-row">
    <span class="ot-wizard-title ot-m-1" i18n>Synchronize a product between environments</span>
  </div>
  <app-wizard [index]="index" [steps]="steps"></app-wizard>
  <div class="ot-wizard-panel-body">
    <ng-scrollbar>
      @if (state == SyncSolutionState.SOURCE) {
      <div animate.enter="enter-animation">
        <div class="ot-row">
          <span class="ot-wizard-title ot-m-1" i18n>Select an environment/solution to synchronize from</span>
        </div>
        @if (!analyzing && syncCapabilityError) {
        <div id="sync-capability-error" class="ot-message ot-message--is-error w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>
              Failed to retrieve product synchronization capabilities.
            </p>
          </div>
        </div>
        }
        <div class="wizard-contents"
          [ngStyle]="{'height': syncCapabilityError ? 'calc(100vh - 434px)' : 'calc(100vh - 372px)' }">
          <div class="ot-row">
            <div class="ot-row__column">
              <app-select [identifier]="'sync-from-env'" [options]="sourceEnvs" [label]="'Source environment/solution'"
                i18n-placeholder placeholder="Select source" (selected)="onSourceSolSelected($event)">
              </app-select>
            </div>
            <div class="ot-row__column"></div>
            <div class="ot-row__column"></div>
          </div>
          <div class="ot-row">
            <div class="ot-row__column">
              <app-select [identifier]="'sync-from-product'" [options]="sourceProducts" [label]="'Product name'"
                i18n-placeholder placeholder="Select a product" (selected)="onProductSelected($event)"
                [readonly]="sourceProducts.length == 0">
              </app-select>
            </div>
            <div class="ot-row__column">
              <app-select [identifier]="'sync-from-version'" [options]="sourceVersions" [label]="'Product version'"
                i18n-placeholder placeholder="Select a version" (selected)="onVersionSelected($event)"
                [readonly]="sourceVersions.length == 0">
              </app-select>
            </div>
            <div class="ot-row__column"></div>
          </div>
        </div>
      </div>
      }
      @if (state == SyncSolutionState.TYPE) {
      <div animate.enter="enter-animation">
        <div class="ot-row">
          <span class="ot-wizard-title ot-m-1" i18n>Select the synchronization type</span>
        </div>
        <div class="wizard-contents" style="height: calc(100vh - 372px);">
          <div class="ot-row">
            <div class="ot-row__column">
              <app-select [identifier]="'sync-type'" [options]="supportedTypeOptions" [label]="'Type'" i18n-placeholder
                placeholder="Select type" (selected)="onTypeSelected($event)">
              </app-select>
            </div>
            <div class="ot-row__column"></div>
            <div class="ot-row__column"></div>
          </div>
        </div>
      </div>
      }
      @if (state == SyncSolutionState.TARGET) {
      <div animate.enter="enter-animation">
        @if (showNoCompatiblePlatformError) {
        <div class="ot-row" style="margin-bottom: 0px !important;">
          <div id="no-compatible-platform-error-banner" class="ot-message ot-message--is-error w-100">
            <div class="ot-message__banner">
              <p id="no-compatible-platform-text" class="ot-message__item" i18n>The selected target environnment does
                not contain an instance with the platform {{selectedVersion.platform}}.</p>
            </div>
          </div>
        </div>
        }
        <div class="ot-row">
          <span class="ot-wizard-title ot-m-1" i18n>Select the synchronization target</span>
        </div>
        <div class="wizard-contents"
          [ngClass]="{'target': !showNoCompatiblePlatformError, 'target-with-error': showNoCompatiblePlatformError}">
          <div class="ot-row">
            <div class="ot-row__column">
              <app-select [identifier]="'sync-to-env'" [options]="targetEnvs" [label]="'Target environment/solution'"
                i18n-placeholder placeholder="Select target" (selected)="onTargetSelected($event)">
              </app-select>
            </div>
            <div class="ot-row__column"></div>
            <div class="ot-row__column"></div>
          </div>
          <div class="ot-row">
            <app-datatable [identifier]="'sync-instance-table'" style="width: 100%" [disableSelectAllCheckbox]="true"
              [recountSelectedRow]="recountSelectedRow" [showcheckboxes]="true" [overrideShowError]="true"
              [cols]="instanceCols" [rows]="instanceRows" [scroll]="false">
            </app-datatable>
          </div>
        </div>
      </div>
      }
      @if (state == SyncSolutionState.ANALYZE) {
      <div animate.enter="enter-animation">
        <div class="ot-row">
          <p class="ot-wizard-msg-text ot-pt-1" i18n>The systems need to be validated by performing an analysis
            before the synchronization can begin.
          </p>
        </div>
        @if (analyzing) {
        <div id="sync-analysis" class="ot-message ot-message--is-progress w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>{{progressText}}</p>
          </div>
        </div>
        }
        @if (!analyzing && isAnalysisSuccess) {
        <div id="sync-analysis-success" class="ot-message ot-message--is-success w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>The analysis has completed successfully.</p>
          </div>
        </div>
        }
        @if (isSynced) {
        <div id="sync-analysis-synced" class="ot-message ot-message--is-success w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>No action required. Products from both source and target
              environment/solution are already synchronized.</p>
          </div>
        </div>
        }
        @if (!analyzing && isError) {
        <div id="sync-analysis-error" class="ot-message ot-message--is-error w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item">
              {{errorMessage}}
            </p>
          </div>
        </div>
        }
        <div style="height: calc(100vh - 446px);">
          @if (!analyzing && needsUpdate) {
          <ng-scrollbar>
            <div class="wizard-contents">
              <ul class="ot-list ot-list--is-high-density">
                @for (item of analysisResultList; track item) {
                <li data-name="message" tabindex="-1" class="ot-list__item">
                  @if (item.imgSrc != undefined && item.imgSrc != '') {
                  <img data-name="message-icon" [src]="item.imgSrc" class="ot-list__icon">
                  }
                  <div class="ot-list__item--is-body">
                    @if (item.name != undefined && item.name != '') {
                    <div class="ot-level">
                      <div class="ot-level__left">
                        <div data-name="message-name" class="ot-level__item">
                          <strong>{{item.name}}</strong>
                        </div>
                      </div>
                    </div>
                    }
                    <p class="ot-message-body" data-name="message-text" [innerHtml]="item.msg"></p>
                  </div>
                </li>
                }
              </ul>
              @if (needsUpdate && canUpdate && !isError) {
              <div>
                <p id="analyzeProductProceedQuestion" i18n>Would you like to continue?</p>
              </div>
              }
              @if (!analyzing && !canUpdate && canSkipWarnings && !isSynced) {
              <div class="ot-row">
                <p id="analyzeProductSkipWarningDesc" i18n>Proceeding with the operation may leave the
                  selected
                  product in target environment/solution in a configuration that is not consistent with
                  the
                  product
                  from source environment/solution.</p>
              </div>
              }
              @if (!analyzing && additionalModuleWarning && !isSynced && this.canSkipWarnings) {
              <div class="ot-row">
                <app-checkbox [identifier]="'skipAdditionalModules'" [(ngModel)]="skipAdditionalModules" i18n-label
                  [label]="'I choose to proceed even though additional module(s) are installed on the selected system.'"
                  i18n-arialabel
                  [arialabel]="'I choose to proceed even though additional module(s) are installed on the selected system.'">
                </app-checkbox>
              </div>
              }
              @if (!analyzing && missingModuleWarning && !isSynced && this.canSkipWarnings) {
              <div class="ot-row">
                <app-checkbox [identifier]="'skipMissingModules'" [(ngModel)]="skipMissingModules" i18n-label
                  [label]="'I choose to proceed even though required module(s) are missing from the selected system.'"
                  i18n-arialabel
                  [arialabel]="'I choose to proceed even though required module(s) are missing from the selected system.'">
                </app-checkbox>
              </div>
              }
              @if (!analyzing && additionalPatchWarning && !isSynced && this.canSkipWarnings) {
              <div class="ot-row">
                <app-checkbox [identifier]="'skipAdditionalPatches'" [(ngModel)]="skipAdditionalPatches" i18n-label
                  [label]="'I choose to proceed even though additional patch(es) are installed on the selected system.'"
                  i18n-arialabel
                  [arialabel]="'I choose to proceed even though additional patch(es) are installed on the selected system.'">
                </app-checkbox>
              </div>
              }
              @if (!analyzing && customLangPackWarning && !isSynced && this.canSkipWarnings) {
              <div class="ot-row">
                <app-checkbox [identifier]="'skipCustomLangs'" [(ngModel)]="skipCustomLangs" i18n-label
                  [label]="'I choose to proceed even though custom language packs are installed on the selected system.'"
                  i18n-arialabel
                  [arialabel]="'I choose to proceed even though custom language packs are installed on the selected system.'">
                </app-checkbox>
              </div>
              }
              @if (!analyzing && unknownPatchWarning && !isSynced && this.canSkipWarnings) {
              <div class="ot-row">
                <app-checkbox [identifier]="'skipUnknownPatch'" [(ngModel)]="skipUnknownPatch" i18n-label
                  [label]="'I choose to proceed even though unknown patches were found.'" i18n-arialabel
                  [arialabel]="'I choose to proceed even though unknown patches were found.'">
                </app-checkbox>
              </div>
              }
            </div>
          </ng-scrollbar>
          }
        </div>
      </div>
      }
      @if (state == SyncSolutionState.DOWNLOAD) {
      <div animate.enter="enter-animation">
        @if (!isValidatingPackages && missingPatchesToReapply > 0) {
        <div class="ot-message ot-message--is-warning">
          <div class="ot-message__banner">
            <div class="ot-message__item d-inline">
              <div i18n style="padding-top:5px" id="otsc-acknowledge-skip-reapply-msg">
                OpenText recommends that you complete this step. Skipping this step will revert to 24.1 or earlier
                behavior and not reapply patches.<br />
              </div>
              <div style="font-size:18px !important">
                <app-checkbox [identifier]="'otsc-acknowledge-missing-cb'" [(ngModel)]="isAcknowledgedSkipMissing"
                  [inheritstyle]="true" i18n-label [label]="'I want to skip reapplying patches.'" i18n-arialabel
                  [arialabel]="'I want to skip reapplying patches.'">
                </app-checkbox>
              </div>
            </div>
          </div>
        </div>
        }
        <div class="ot-row">
          <p class="ot-wizard-msg-text ot-pt-1" i18n>The selected product requires synchronization. The system
            will now validate the list of required packages.</p>
        </div>
        <div class="ot-row">
          @if (needsDownload) {
          <div class="ot-ml-1 ot-mb-1">
            @if (needsDownload && isOnlineMode) {
            <button id="download-missing-packages" role="button" otsc-button [disabled]="isDownloading" color="primary"
              (click)="download()" i18n>Download
              {{getDownloadCount()}} item(s)</button>
            }
            @if (needsDownload && !isOnlineMode) {
            <button id="upload-missing-packages" role="button" otsc-button [disabled]="isDownloading" color="primary"
              (click)="openOfflineUpload()" i18n>Upload
              {{getDownloadCount()}} item(s)</button>
            }
          </div>
          }
        </div>
        @if (isValidatingPackages && !isError) {
        <div id="sync-validating-downloads" class="ot-message ot-message--is-progress w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>
              Validating required packages...
            </p>
          </div>
        </div>
        }
        @if (isDownloading && !isError) {
        <div id="sync-waiting-downloads" class="ot-message ot-message--is-progress w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>
              Please wait while the required package(s) are downloaded...
            </p>
          </div>
        </div>
        }
        @if (!isDownloading && !isValidatingPackages && isValidatingPackagesComplete && getDownloadCount() == 0 &&
        !isError) {
        <div id="sync-validation-success" class="ot-message ot-message--is-success w-100">
          <div class="ot-message__banner">
            @if (isOnlineMode) {
            <p class="ot-message__item" i18n>All of the required packages have
              been downloaded.</p>
            }
            @if (!isOnlineMode) {
            <p class="ot-message__item" i18n>All of the required packages have
              been uploaded.</p>
            }
          </div>
        </div>
        }
        @if (!isDownloading && !isValidatingPackages && isValidatingPackagesComplete && getDownloadCount() > 0 &&
        !isError) {
        <div id="sync-validation-warning" class="ot-message ot-message--is-warning w-100">
          <div class="ot-message__banner">
            @if (needsDownload) {
            <p class="ot-message__item" i18n>{{getMissingDownloadMessage()}}</p>
            }
          </div>
        </div>
        }
        @if (isError) {
        <div id="sync-validation-error" class="ot-message ot-message--is-error w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item">
              {{errorMessage}}
            </p>
          </div>
        </div>
        }
        <div class="ot-row">
          <app-datatable [identifier]="'sync-packages-table'" [cols]="packageCols" [rows]="packageRows"
            [sortdata]="false" [showcheckboxes]="false" (actionmenuevent)="downloadActionMenuClicked($event)"
            [scroll]="false"></app-datatable>
        </div>
      </div>
      }
      @if (state == SyncSolutionState.VALIDATE) {
      <div animate.enter="enter-animation">
        <div class="ot-row">
          <p class="ot-wizard-msg-text ot-pt-1" i18n>
            Before System Center Manager applies an Update to your Content Server environment, it
            verifies conditions on the Content Server instances to ensure that it can apply the Update
            successfully. If there are no problems, you can proceed with the Update. If the Prerequisite checks
            dialog
            box displays warnings or errors, you normally must resolve the underlying problems before you
            can proceed. If a check fails, click the instance below to review the message. Once the problem
            is fixed, click Retry to try again.
          </p>
        </div>
        @if (!preReqCheckInProcess && !preReqCheckWaiting && preReqCheckSuccess && !isError) {
        <div id="sync-instance-pre-flight-success" class="ot-message ot-message--is-success w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>
              Prerequisite checks passed successfully.
            </p>
          </div>
        </div>
        }
        @if (!preReqCheckInProcess && !preReqCheckSuccess && !preReqCheckWaiting && !isError) {
        <div id="sync-instance-pre-flight-failed" class="ot-message ot-message--is-error w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>
              Prerequisite checks failed. Please review the error for each instance.
            </p>
          </div>
        </div>
        }
        @if (preReqCheckInProcess && !isError) {
        <div id="sync-instance-pre-flight-running" class="ot-message ot-message--is-progress w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>
              Running prerequisite checks. Please wait...
            </p>
          </div>
        </div>
        }
        @if (preReqCheckWaiting) {
        <div id="sync-instance-pre-flight-waiting" class="ot-message ot-message--is-progress w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>
              Waiting to run prerequisite checks...
            </p>
          </div>
        </div>
        }
        @if (isError) {
        <div id="solution-sync-error-pre-flight" id="sync-instance-pre-flight-error"
          class="ot-message ot-message--is-error w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item">
              {{errorMessage}}
            </p>
          </div>
        </div>
        }
        @if (preReqRegisteredServerCheck.missingHosts.length > 0) {
        <div id="solution-sync-error-missing-host" class="ot-message ot-message--is-error">
          @if (preReqRegisteredServerCheck.missingHosts.length > 0) {
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>
              {preReqRegisteredServerCheck.missingHosts.length,
              plural,
              =1 {
              Unmanaged instance was found.
              }
              other {{{preReqRegisteredServerCheck.missingHosts.length}} unmanaged instances were found.}
              }
              &nbsp;@if (csInfo.isHostManagement) {
              <a (click)="showPreReqErrorDetails('MISSING')">Unregister
                systems</a>
              }
              @if (!csInfo.isHostManagement) {
              <a (click)="showPreReqErrorDetails('MISSING')">View details</a>
              }
            </p>
          </div>
          }
        </div>
        }
        @if (preReqRegisteredServerCheck.additionalHosts.length > 0) {
        <div id="solution-sync-error-unclustered" class="ot-message ot-message--is-error">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>
              {preReqRegisteredServerCheck.additionalHosts.length,
              plural,
              =1 {
              Unclustered instance was found.
              }
              other {{{preReqRegisteredServerCheck.missingHosts.length}} unclustered instances were found.}
              }
              &nbsp;<a (click)="showPreReqErrorDetails('ADDITIONAL')">View details</a>
            </p>
          </div>
        </div>
        }
        <div class="ot-row">
          <app-datatable [identifier]="'sync-instance-table'" style="width: 100%" [disableSelectAllCheckbox]="true"
            [recountSelectedRow]="recountSelectedRow" [showcheckboxes]="true" [title]="''" [overrideShowError]="true"
            [cols]="preReqTableCols" [rows]="preFlightInstanceRows" (actionmenuevent)="actionMenuClicked($event)"
            (onclickrowlink)="viewPrereqDetails($event)" [showIconColumn]="true" [scroll]="false">
          </app-datatable>
        </div>
      </div>
      }
      @if (state == SyncSolutionState.SYNC) {
      <div animate.enter="enter-animation">
        <div class="ot-row">
          @if (!this.targetProduct.supportsHotfix) {
          <p class="ot-pl-1 ot-pr-1" style="font-size: 16px;" i18n>
            Please confirm the the selected update to install. The selected update will overwrite files and may
            make irreversible changes. Before you apply this update, make a full backup of your installation and
            database.
          </p>
          }
          @if (this.targetProduct.supportsHotfix) {
          <div class="ot-pl-1 ot-pr-1">
            <p class="ot-mb-0" style="font-size: 16px;" i18n>
              The following list may contain the quarterly Update, Language Packs, and Patches to be installed or
              removed.
            </p>
            <p style="font-size: 16px;" i18n>
              Content Server Updates overwrite files and may make irreversible changes to your Content Server
              database. Before you apply this Update, make a full backup of your Content Server installation,
              including the Search Index, database, External File Store, and the Content_Server_home folder.
            </p>
          </div>
          }
        </div>
        @if (isSendingPatchInstall) {
        <div class="ot-message ot-message--is-progress w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>
              Sending patch installation request. Please wait...
            </p>
          </div>
        </div>
        }
        @if (isInstalling && !isError && !isSendingPatchInstall) {
        <div id="sync-install-started" class="ot-message ot-message--is-success w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item">
              <span i18n>The system is installing the required packages. To view the installation
                status please
                <a (click)="goToActivities()">
                  <span> click here</span>.
                </a>
              </span>
            </p>
          </div>
        </div>
        }
        @if (isError) {
        <div id="sync-install-error" id="sync-instance-pre-flight-error" class="ot-message ot-message--is-error w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item">
              {{errorMessage}}
            </p>
          </div>
        </div>
        }
        <div>
          <div class="ot-panel__header">
            <app-tabs [identifier]="'solutions-sync-tabs'" (selected)="onSelectedTabChange($event)" [tabs]="tabs"
              [color]="TabColor.SECONDARY" [selectedIndex]="activeTab"></app-tabs>
          </div>
          @if (activeTab == SyncTab.PACKAGES) {
          <div>
            <app-datatable [identifier]="'sync-applyItems-table'" (actionmenuevent)="downloadActionMenuClicked($event)"
              [isloading]="!isApplyItemsReady" [showcheckboxes]="false" [title]="null" [cols]="applyItemsCols"
              [rows]="applyItemsRows" [scroll]="false">
            </app-datatable>
          </div>
          }
          @if (activeTab == SyncTab.INSTANCE) {
          <div>
            <app-datatable [identifier]="'sync-instances-table'" [cols]="preReqTableCols" [rows]="preFlightInstanceRows"
              [sortdata]="false" [scroll]="false">
            </app-datatable>
          </div>
          }
        </div>
      </div>
      }
    </ng-scrollbar>
  </div>
  <div class="ot-wizard-panel-footer ot-wizard-panel-footer--is-right-justified">
    @if (state == SyncSolutionState.SOURCE) {
    <div class="ot-btn-group ot-wizard-panel-footer-btn-group">
      @if (syncCapabilityError) {
      <button id="source-retry-button" role="button" otsc-button color="primary" (click)="getSyncCapabilities()"
        i18n>Retry</button>
      }
      <button id="source-next-button" role="button" otsc-button color="primary" (click)="next()"
        [disabled]="selectedVersion == undefined" i18n>Next</button>
      <button id="source-cancel-button" role="button" otsc-button color="secondary" (click)="cancel()"
        i18n>Cancel</button>
    </div>
    }
    @if (state == SyncSolutionState.TYPE) {
    <div class="ot-btn-group ot-wizard-panel-footer-btn-group">
      <button id="type-back-button" role="button" otsc-button color="secondary" [disabled]="isValidatingPackages"
        (click)="back()" i18n>Back</button>
      <button id="type-next-button" role="button" otsc-button color="primary" (click)="next()"
        [disabled]="selectedType == undefined" i18n>Next</button>
      <button id="type-cancel-button" role="button" otsc-button color="secondary" (click)="cancel()"
        i18n>Cancel</button>
    </div>
    }
    @if (state == SyncSolutionState.TARGET) {
    <div class="ot-btn-group ot-wizard-panel-footer-btn-group">
      <button id="target-back-button" role="button" otsc-button color="secondary" (click)="back()" i18n>Back</button>
      <button id="target-next-button" role="button" otsc-button color="primary" (click)="next()"
        [disabled]="selectedTargetEnv == undefined || showNoCompatiblePlatformError || this.instanceRows == undefined || this.instanceRows.length == 0"
        i18n>Next</button>
      <button id="target-cancel-button" role="button" otsc-button color="secondary" (click)="cancel()"
        i18n>Cancel</button>
    </div>
    }
    @if (state == SyncSolutionState.ANALYZE) {
    <div class="ot-btn-group ot-wizard-panel-footer-btn-group">
      @if (result == undefined && !isSynced) {
      <button id="analyze-back-button" role="button" otsc-button color="secondary" (click)="back()"
        [disabled]="analyzing" i18n>Back</button>
      }
      @if (result == undefined && isError && !isSynced) {
      <button id="analyze-retry-button" [disabled]="analyzing" role="button" otsc-button color="primary"
        (click)="analyze()" i18n>Retry</button>
      }
      @if (result == undefined && !isSynced) {
      <button id="analyze-next-button" role="button" otsc-button color="primary" (click)="next()"
        [disabled]="isNextDisabled()" i18n>Next</button>
      }
      @if (result != undefined && !isSynced) {
      <button id="analyze-products-button" role="button" otsc-button color="primary" (click)="goToProducts()"
        [disabled]="analyzing" i18n>Products</button>
      }
      @if (result == undefined && !isSynced) {
      <button id="analyze-cancel-button" role="button" otsc-button color="secondary" (click)="cancel()"
        i18n>Cancel</button>
      }
      @if (isSynced) {
      <button id="analyze-finish-button" role="button" otsc-button color="primary" (click)="cancel()"
        i18n>Finish</button>
      }
    </div>
    }
    @if (state == SyncSolutionState.DOWNLOAD) {
    <div class="ot-btn-group ot-wizard-panel-footer-btn-group">
      <button id="validate-back-button" role="button" otsc-button color="secondary" [disabled]="isValidatingPackages"
        (click)="back()" i18n>Back</button>
      @if (isError || needsDownload) {
      <button id="validate-retry-button" role="button" [disabled]="isValidatingPackages" otsc-button color="primary"
        (click)="validatePackages()" i18n>Retry</button>
      }
      <button id="validate-next-button" [disabled]="isDownloadNextDisabled()" role="button" otsc-button color="primary"
        (click)="next()" i18n>Next</button>
      <button id="validate-cancel-button" role="button" [disabled]="isValidatingPackages" otsc-button color="secondary"
        (click)="cancel()" i18n>Cancel</button>
    </div>
    }
    @if (state == SyncSolutionState.VALIDATE) {
    <div class="ot-btn-group ot-wizard-panel-footer-btn-group">
      <button id="validate-back-button" role="button" otsc-button color="secondary" [disabled]="preReqCheckInProcess"
        (click)="back()" i18n>Back</button>
      @if (isError || !preReqCheckSuccess) {
      <button id="validate-retry-button" [disabled]="preReqCheckInProcess || preReqCheckWaiting || preReqCheckSuccess"
        role="button" otsc-button color="primary" (click)="validate()" i18n>Retry</button>
      }
      <button id="validate-next-button" [disabled]="preReqCheckInProcess || !preReqCheckSuccess" role="button"
        otsc-button color="primary" (click)="next()" i18n>Next</button>
      <button id="validate-cancel-button" role="button" [disabled]="preReqCheckInProcess" otsc-button color="secondary"
        (click)="cancel()" i18n>Cancel</button>
    </div>
    }
    @if (state == SyncSolutionState.SYNC) {
    <div class="ot-btn-group ot-wizard-panel-footer-btn-group">
      @if (!isInstalling) {
      <button id="sync-back-button" role="button" otsc-button color="secondary" (click)="back()" i18n>Back</button>
      }
      @if (!isInstalling) {
      <button id="sync-button" role="button" otsc-button color="primary" (click)="startSync()"
        [disabled]="isInstalling || isSendingPatchInstall">Synchronize</button>
      }
      @if (!isInstalling) {
      <button id="sync-cancel-button" role="button" otsc-button color="secondary" (click)="cancel()"
        i18n>Cancel</button>
      }
      @if (isInstalling) {
      <button id="sync-finish-button" role="button" otsc-button color="primary" (click)="cancel()" i18n>Finish</button>
      }
    </div>
    }
  </div>
</div>